/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It parses your text as strict JSON and reports the first syntax error, including the line and column where it was found when your browser provides it.`)
};

const es_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analiza tu texto como JSON estricto e informa el primer error de sintaxis, incluyendo la línea y columna donde fue encontrado cuando tu navegador lo proporciona.`)
};

const de_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er analysiert Ihren Text als striktes JSON und meldet den ersten Syntaxfehler, einschließlich der Zeile und Spalte, in der er gefunden wurde, wenn Ihr Browser dies bereitstellt.`)
};

const nl_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het parseert je tekst als strikte JSON en rapporteert de eerste syntaxisfout, inclusief de regel en kolom waar deze werd gevonden wanneer je browser dit levert.`)
};

const fr_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il analyse votre texte en tant que JSON strict et signale la première erreur de syntaxe, y compris la ligne et la colonne où elle a été trouvée quand votre navigateur le fournit.`)
};

const it_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analizza il tuo testo come JSON rigoroso e segnala il primo errore di sintassi, inclusa la riga e la colonna in cui è stato trovato quando il tuo browser lo fornisce.`)
};

const pt_br2_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele analisa seu texto como JSON estrito e relata o primeiro erro de sintaxe, incluindo a linha e coluna onde foi encontrado quando seu navegador fornece.`)
};

const pt_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisa o seu texto como JSON rigoroso e relata o primeiro erro de sintaxe, incluindo a linha e a coluna onde foi encontrado quando o seu navegador o fornece.`)
};

const ja_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストを厳密なJSONとして解析し、ブラウザが提供する場合は見つかった行と列を含む最初の構文エラーを報告します。`)
};

const zh_jf_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它会将您的文本按严格的 JSON 规则进行解析，并报告第一个语法错误；当浏览器提供相关信息时，还会显示该错误所在的行号和列号。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const jf_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jf_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("jf_faq2_a", locale)
	if (locale === "en") return en_jf_faq2_a(inputs)
	if (locale === "es") return es_jf_faq2_a(inputs)
	if (locale === "de") return de_jf_faq2_a(inputs)
	if (locale === "nl") return nl_jf_faq2_a(inputs)
	if (locale === "fr") return fr_jf_faq2_a(inputs)
	if (locale === "it") return it_jf_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_jf_faq2_a(inputs)
	if (locale === "pt") return pt_jf_faq2_a(inputs)
	if (locale === "ja") return ja_jf_faq2_a(inputs)
	return zh_jf_faq2_a(inputs)
};